module.exports = __webpack_public_path__ + "img/intro.2fda24be.png";